import React from 'react'
import st from './Buttons.module.scss'
import useLocalization from 'hooks/useLocalization'

const Buttons = ({
  actions,
  onTabChange,
  selectedTab,
  checkedStates,
  selectedUser,
  clickedId,
}) => {
  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      delete: 'Delete',
      dontMerge: 'Don’t Merge',
      merging: 'Merge',
      save: 'Save',
    },
  })

  const isAnyFieldNull = Object.values(checkedStates).some(
    (value) => value === null,
  )

  const isSaveDisabled =
    isAnyFieldNull && selectedUser === null && clickedId === null

  return (
    <div className={st.container}>
      <div className={st.status}>{actions[selectedTab].label}</div>
      <div className={st.buttonsContainer}>
        <div
          className={`${st.disableBtn} ${selectedTab === 'delete' && st.activeBtn}`}
          onClick={() => onTabChange('delete')}
        >
          {translate?.delete}
        </div>
        <div
          className={`${st.disableBtn} ${selectedTab === 'dontMerge' && st.activeBtn}`}
          onClick={() => onTabChange('dontMerge')}
        >
          {translate?.dontMerge}
        </div>
        <div
          className={`${st.disableBtn} ${selectedTab === 'merging' && st.activeBtn}`}
          style={{ padding: '10px 36px' }}
          onClick={() => onTabChange('merging')}
        >
          {translate?.merging}
        </div>
      </div>
      <div>
        <button
          className={st.saveBtn}
          style={{ padding: '10px 36px' }}
          onClick={actions[selectedTab].onSave}
          disabled={isSaveDisabled}
        >
          {translate?.save}
        </button>
      </div>
    </div>
  )
}

export default Buttons
